import { useEffect, useState } from "react";
import httpClient from '../../HTTPService';
import { useParams } from "react-router-dom";

const MemberList = () => {
  const { userId, level } = useParams();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (userId && level) {
      fetchDepthMembers();
    }
  }, [userId, level]);

  const fetchDepthMembers = async () => {
    try {
      const result = await httpClient.post(
        "/admin/depth-member-list",
        { user_id: userId, level: level },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (result.status === 200 && Array.isArray(result.data?.data)) {
        console.log("Depth members response", result.data.data);

        setMembers(result.data?.data);
      }
    } catch (error) {
      //   toast.error(error.message)
    }
  };


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>SL NO</th>
                  <th>Member ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Address</th>
                  <th>Joing Date</th>
                  <th>Member Code</th>
                  <th>Position</th>
                </tr>
              </thead>
              <tbody>
                {members.map((member, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{member.id}</td>
                    <td>{member.name}</td>
                    <td>{member.email}</td>
                    <td>{member.phone}</td>
                    <td>{member.joing_date}</td>
                    <td>{member.member_code}</td>

                    <td>{member.position}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemberList
